import {
  colLgWidth,
  colMdWidth,
  colSmWidth,
  colXsWidth
} from '@bo-constants/member/memberPayments';
import type { Deposit } from '@library/types/payments';
import { StatusIcon } from '@library/components/StatusIcon';
import { classNames } from '@library/utils';
import { formatMemberDepositDetails } from '@bo-utils/members/memberPayments';

export interface MemberDepositsTableRowProps {
  deposit: Deposit;
  onRowClick: (id: string) => void;
}

export const MemberDepositsTableRow = ({
  deposit,
  onRowClick
}: MemberDepositsTableRowProps) => {
  const { merchantReferenceId, status } = deposit;
  const {
    createdDateTime,
    depositStatus,
    formattedAmount,
    formattedMethodInfo,
    stateAbbreviation
  } = formatMemberDepositDetails(deposit);

  const colClasses = 'flex flex-1 p-3';

  return (
    <div
      aria-hidden="true"
      className="border-soFresh-140 text-soClean-110 hover:bg-soFresh-120 group/user text-2xs relative flex h-16 cursor-pointer items-center border-b xl:text-xs"
      data-testid={`member-deposits-row-${merchantReferenceId}`}
      onClick={() => onRowClick(merchantReferenceId)}
    >
      <p
        className={classNames(colClasses, colLgWidth)}
        data-testid="member-deposit-id"
      >
        {merchantReferenceId}
      </p>
      <p
        className={classNames(colClasses, colSmWidth)}
        data-testid="member-deposit-amount"
      >
        {formattedAmount}
      </p>
      <p
        className={classNames(colClasses, colMdWidth)}
        data-testid="member-deposit-method"
      >
        {formattedMethodInfo}
      </p>
      <p
        className={classNames(colClasses, colXsWidth)}
        data-testid="member-deposit-state"
      >
        {stateAbbreviation}
      </p>
      <p
        className={classNames(colClasses, colMdWidth, 'flex-col')}
        data-testid="member-deposit-createdAt"
      >
        <span className="leading-5">{createdDateTime.date}</span>
        <span className="text-soClean-160">{createdDateTime.time}</span>
      </p>
      <div
        className={classNames(colClasses, colSmWidth, 'items-center')}
        data-testid="member-deposit-status"
      >
        <StatusIcon status={status} classes="!size-2 !mr-1.5" />
        <span>{depositStatus}</span>
      </div>
    </div>
  );
};
